// ink-component
import React from 'react';
import styled from 'styled-components';

import VerticalNavAnchor from './components/VerticalNavAnchor/VerticalNavAnchor';
import VerticalNavButton from './components/VerticalNavButton/VerticalNavButton';
import VerticalNavItem from './components/VerticalNavItem/VerticalNavItem';

export type VerticalNavProps = React.HTMLAttributes<HTMLElement>;

const VerticalNavWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: baseline;
`;

/**
 * @group VerticalNav
 * @purpose Create page side navigation
 * @categories navigation
 */
const VerticalNav = (props: VerticalNavProps) => (
  <VerticalNavWrapper role="navigation">{props.children}</VerticalNavWrapper>
);

VerticalNav.Anchor = VerticalNavAnchor;
VerticalNav.Button = VerticalNavButton;
VerticalNav.Item = VerticalNavItem;

export { VerticalNavAnchorProps } from './components/VerticalNavAnchor/VerticalNavAnchor';
export { VerticalNavButtonProps } from './components/VerticalNavButton/VerticalNavButton';
export { VerticalNavItemProps } from './components/VerticalNavItem/VerticalNavItem';

VerticalNav.displayName = 'VerticalNav';

export default VerticalNav;
